export default __webpack_public_path__ + "static/media/user-06.98e7a260.jpg";